import { render } from "./Especialidad_EspeMedi.vue?vue&type=template&id=6b88df4a"
import script from "./Especialidad_EspeMedi.vue?vue&type=script&lang=js"
export * from "./Especialidad_EspeMedi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__